module.exports = __webpack_public_path__ + "img/brush.82e19380.svg";